import axios from 'axios';
import { isTokenValid } from './utils/tokenUtils';

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:3004/api',
});

api.interceptors.request.use(
  config => {
    // Skip token validation for authentication endpoints
    const authEndpoints = ['/login', '/register', '/verify-email', '/forgot-password', '/reset-password', '/googleLogin', '/appleLogin'];
    const isAuthEndpoint = authEndpoints.some(endpoint => config.url?.includes(endpoint));
    
    if (!isAuthEndpoint) {
      const token = localStorage.getItem('token'); 
      if (token) {
        // Check if token is valid before sending request
        if (isTokenValid(token)) {
          config.headers.Authorization = `Bearer ${token}`;
        } else {
          // Token is expired, remove it and redirect to login
          localStorage.removeItem('token');
          // Force a page reload to update auth state
          if (window.location.pathname.startsWith('/app')) {
            window.location.href = '/login';
          }
          return Promise.reject(new Error('Token expired'));
        }
      }
    } else {
      // For auth endpoints, still add token if it exists (for some endpoints that might need it)
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      const message = error.response?.data?.message || '';
      // Only treat 401 as session expiration if it's not a password validation message
      if (!message.toLowerCase().includes('password')) {
        localStorage.removeItem('token');
        // Redirect to login if on a protected route
        if (window.location.pathname.startsWith('/app')) {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;